// extracted by mini-css-extract-plugin
module.exports = {"popoverContent":"PopoverImageComponent_popoverContent__8YCJj","activePop":"PopoverImageComponent_activePop__1W6iu"};